var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPageNotFound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 393,
    height: 360,
    viewBox: "0 0 393 360",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M63.3706 64.4897L31.8388 163.725L38.5931 175L40.8454 163.725L83.6386 84.7865L108.414 109.595L101.657 107.34C97.1522 107.34 97.1522 107.34 94.9 111.851C93.0981 115.459 109.164 126.886 117.423 132.149H130.936L126.432 156.957L133.189 163.725L144.45 141.17L162.468 163.725C166.072 156.508 184.991 150.192 194 147.936L157.964 127.638L180.486 116.361L173.73 111.851L146.702 116.361V105.085C142.948 97.5668 134.54 82.0801 130.936 80.2759C127.333 78.4716 124.93 82.5312 124.18 84.7865V91.5526L101.657 68.9992L180.486 23.8925L194 21.6371L175.982 17.1265L79.134 46.4458L31.8388 3.59563C9.31603 -7.68106 16.0728 10.3616 20.5774 19.383C24.181 26.6001 50.6077 52.4612 63.3706 64.4897Z",
    fill: "#CA3657"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3120_2451)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11 339C14.0672 327.756 32.4706 302.2 81.5462 289.933C90.7479 167.257 262.513 75.2526 376 197.933",
    stroke: "#808080",
    strokeWidth: 8,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3120_2451",
    x: 0,
    y: 133.001,
    width: 393,
    height: 227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3,
    dy: 7
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0 0.501961 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3120_2451"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3120_2451",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageNotFound);
export default __webpack_public_path__ + "static/media/page-not-found.e4fc3174fed69dab3e17bd6b83df8944.svg";
export { ForwardRef as ReactComponent };